import { render, staticRenderFns } from "./HistoricalOutliersTable.vue?vue&type=template&id=25f2f7a6&scoped=true&"
import script from "./HistoricalOutliersTable.vue?vue&type=script&lang=ts&"
export * from "./HistoricalOutliersTable.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricalOutliersTable.vue?vue&type=style&index=0&id=25f2f7a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f2f7a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDataTable,VDivider,VIcon,VListItem,VListItemContent,VListItemTitle,VSelect})
